import { render, staticRenderFns } from "./PerformanceLog.vue?vue&type=template&id=fc490386&"
import script from "./PerformanceLog.vue?vue&type=script&lang=js&"
export * from "./PerformanceLog.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceLog.vue?vue&type=style&index=0&id=fc490386&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports